import i18n from "../services/i18n"
export const ERROR_MAPPINGS: Record<string, string> = {
  EMAIL_CAN_NOT_BE_EMPTY: i18n.t("errEmailEmpty"),
  PASSWORD_OR_CONFIRMPASSWORD_CAN_NOT_BE_EMPTY: i18n.t("errPasswordRequired"),
  INVALID_CONFIRM_PASSWORD: i18n.t("errPasswordsMismatch"),
  NOT_A_VALID_EMAIL: i18n.t("errEmailFormat"),
  A_USER_IS_REGISTERED_WITH_SUCH_A_EMAIL: i18n.t("errEmailTaken"),
  NOT_A_VALID_PASSWORD: i18n.t("errPasswordMin8"),
  AUTH_NOT_AUTHORIZED: i18n.t("errNoRights"),
  THE_QUANTITY_OF_PRODUCTS_IS_NOT_ENOUGH: i18n.t("errInsufficientStock"),
  PRODUCT_NOT_FOUND: i18n.t("errProductNotFound"),
  NULL_MONEY: i18n.t("errPaymentAmount"),
  COUNTERPARTY_NOT_FOUND: i18n.t("errCounterpartyNotFound"),
  FACTORY_NOT_FOUND: i18n.t("errFactoryNotFound"),
  WAREHOUSE_NOT_FOUND: i18n.t("errWarehouseNotFound"),
  THIS_ORDER_NOT_DELETED: i18n.t("errOrderInProcess"),
  "Invalid Credentials": i18n.t("errBadCredentials"),
  "User deleted": i18n.t("errAccountDeleted"),
  "Network Error": i18n.t("errServerConnection"),
  "String empty": i18n.t("errRequiredText")
};

export function translateError(rawMsg: any): string {
  if (!rawMsg) return i18n.t("errUnknown");
  if (typeof rawMsg !== "string") {
    if (rawMsg.message) return translateError(rawMsg.message);
    if (rawMsg.Message) return translateError(rawMsg.Message);
    return JSON.stringify(rawMsg);
  }

  const trimmed = rawMsg.trim();
  if (ERROR_MAPPINGS[trimmed]) {
    return ERROR_MAPPINGS[trimmed];
  }

  if (trimmed.includes("Duplicate entry")) {
    return i18n.t("errDuplicate");
  }
  if (trimmed.includes("foreign key constraint fails") || trimmed.includes("Cannot delete or update a parent row")) {
    return i18n.t("errRecordInUse");
  }
  if (trimmed.includes("An error occurred while updating the entries")) {
    return i18n.t("errDbSave");
  }
  if (trimmed.includes("timeout") || trimmed.includes("Timeout")) {
    return i18n.t("errTimeout");
  }

  return trimmed;
}
